import {
  ArrowUpTrayIcon,
  DocumentCheckIcon,
  EyeIcon,
  GlobeAltIcon,
  PencilSquareIcon,
  StarIcon,
  TrashIcon,
  CheckCircleIcon,
  ClipboardDocumentListIcon,
} from '@heroicons/react/24/outline';
import {
  Braces,
  ClockIcon,
  Edit2Icon,
  CopyIcon as LucideCopyIcon,
  RotateCcw,
  UserRoundPen,
  LockIcon,
  KeyRoundIcon,
} from 'lucide-react';

export const ViewIcon = () => (
  <div className="flex items-center text-text-300">
    <EyeIcon className="size-4 stroke-[2px] mr-2" />
    <span>View Detail</span>
  </div>
);

export const RoleAssignEdit = () => (
  <div className="flex items-center text-text-300">
    <CheckCircleIcon className="size-4 stroke-[2px] mr-2" />
    <span>Edit Role</span>
  </div>
);

export const PermissionAssignedEdit = () => (
  <div className="flex items-center text-text-300">
    <ClipboardDocumentListIcon className="size-4 stroke-[2px] mr-2" />
    <span>Edit Permission</span>
  </div>
);

export const UserChangelogView = () => (
  <div className="flex items-center text-text-300">
    <ClockIcon className="size-4 stroke-[2px] mr-2" />
    <span>User Changelog</span>
  </div>
);

export const RenameIcon = () => (
  <div className="flex items-center text-text-300">
    <Edit2Icon className="size-4 stroke-[2px] mr-2" />
    <span>Rename</span>
  </div>
);

export const MarkGloablIcon = () => (
  <div className="flex items-center text-text-300">
    <GlobeAltIcon className="size-4 stroke-[2px] mr-2" />
    <span>Mark as global</span>
  </div>
);

export const MarkDefaultIcon = () => (
  <div className="flex items-center text-text-300">
    <StarIcon className="size-4 stroke-[2px] mr-2" />
    <span>Mark as default</span>
  </div>
);

export const ProfileIcon = () => (
  <div className="flex items-center text-text-300">
    <UserRoundPen className="size-4 stroke-[2px] mr-2" />
    <span>Profile Photo</span>
  </div>
);

export const EditIcon = () => (
  <div className="flex items-center text-text-300">
    <PencilSquareIcon className="size-4 stroke-[2px] mr-2" />
    <span>Edit</span>
  </div>
);

export const DeleteIcon = () => (
  <div className="flex items-center text-text-300">
    <TrashIcon className="size-4 stroke-[2px] mr-2" />
    <span>Delete</span>
  </div>
);

export const ApprovalLogIcon = () => (
  <div className="flex items-center text-text-300">
    <DocumentCheckIcon className="size-4 stroke-[2px] mr-2" />
    <span>Approval Log</span>
  </div>
);

export const EditViewDetailIcon = () => (
  <div className="flex items-center text-text-300">
    <EyeIcon className="size-4 stroke-[2px] mr-2" />
    <span>Edit/View Detail</span>
  </div>
);

export const PushToErpIcon = () => (
  <div className="flex items-center text-text-300">
    <ArrowUpTrayIcon className="size-4 stroke-[2px] mr-2" />
    <span>Push to ERP</span>
  </div>
);

export const DownloadClaimJSON = () => (
  <div className="flex items-center text-text-300">
    <Braces className="size-4 stroke-[2px] mr-2" />
    <span>Download claim (JSON)</span>
  </div>
);

export const CopyIcon = () => {
  return (
    <div className="flex items-center text-text-300">
      <LucideCopyIcon className="size-4 stroke-[2px] mr-2" />
      <span>Create with Reference</span>
    </div>
  );
};

export const RenewalIcon = () => (
  <div className="flex items-center text-text-300">
    <RotateCcw className="size-4 stroke-[2px] mr-2" />
    <span>Create Renewal Contract</span>
  </div>
);

export const LockModuleIcon = () => (
  <div className="flex items-center text-text-300">
    <LockIcon className="size-4 stroke-[2px] mr-2" />
    <span>Lock/Unlock Module</span>
  </div>
);

export const ChangePasswordIcon = () => (
  <div className="flex items-center text-text-300">
    <KeyRoundIcon className="size-4 stroke-[2px] mr-2" />
    <span>Change Password</span>
  </div>
);
